import Typography from "@mui/material/Typography";

export const inputHeight = 48;
export const profileAccent = "#5f48f6";
export const profileAccentDark = "#4f3bdc";
export const profileAccentSoft = "#f1edff";

export const fieldStyle = {
  "& .MuiInputBase-root": {
    height: inputHeight,
    backgroundColor: "#fff",
    borderRadius: "6px",
    fontSize: 14,
  },
  "& .MuiOutlinedInput-input": {
    padding: "0 14px",
    height: inputHeight,
    display: "flex",
    alignItems: "center",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#cbd6e2",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#aebdce",
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: profileAccent,
    borderWidth: "1px",
  },
  "& .MuiFormHelperText-root": {
    ml: 0,
  },
};

export const compactHelperFieldStyle = {
  ...fieldStyle,
  "& .MuiFormHelperText-root": {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginLeft: 0,
  },
};

const labelStyle = {
  color: "#172033",
  display: "block",
  fontSize: 14,
  fontWeight: 500,
  lineHeight: "20px",
  mb: 0.75,
};

export function FieldLabel({ children }) {
  return <Typography sx={labelStyle}>{children}</Typography>;
}

export function SectionTitle({ children }) {
  return (
    <Typography
      sx={{
        alignItems: "center",
        color: "#111827",
        display: "flex",
        fontSize: 16,
        fontWeight: 700,
        gap: 1,
        lineHeight: 1.35,
        "&::before": {
          backgroundColor: profileAccent,
          borderRadius: "999px",
          content: '""',
          display: "inline-block",
          height: 16,
          width: 3,
        },
      }}
    >
      {children}
    </Typography>
  );
}
